module.exports = __webpack_public_path__ + "static/img/ywlrl.d0b165b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/ywlrl.png
// module id = gUmP
// module chunks = 1